import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { PaymentMethodsSection } from './PaymentMethodsSection';

interface PaymentMethodsTabProps {
  isAccountManager: boolean;
  onOpenCustomerPortal: () => void;
  isOpeningCustomerPortal: boolean;
}

export function PaymentMethodsTab({
  isAccountManager,
  onOpenCustomerPortal,
  isOpeningCustomerPortal
}: PaymentMethodsTabProps) {
  const { t } = useTranslation('billing');

  return (
    <div className="space-y-6">
      {isAccountManager && (
        <Card className="border-indigo-200 bg-indigo-50">
          <CardHeader>
            <div className="flex items-center justify-between">
              <div>
                <div className="mb-1 flex items-center gap-2">
                  <h3 className="text-sm font-medium text-indigo-900">{t('accountManager.title')}</h3>
                  <Badge className="border-indigo-300 bg-indigo-100 text-indigo-900">{t('accountManager.badge')}</Badge>
                </div>
                <p className="text-sm text-indigo-700">{t('accountManager.description')}</p>
              </div>
              <Button
                size="sm"
                className="bg-indigo-600 hover:bg-indigo-700"
                onClick={onOpenCustomerPortal}
                disabled={isOpeningCustomerPortal}
              >
                {isOpeningCustomerPortal ? t('common.loading') : t('accountManager.portalButton')}
              </Button>
            </div>
          </CardHeader>
        </Card>
      )}

      <Card>
        <CardContent className="pt-6">
          <PaymentMethodsSection />
        </CardContent>
      </Card>
    </div>
  );
}
